// extracted by mini-css-extract-plugin
export var Numbers = "Numbers-module--Numbers---WWJg";
export var Number = "Numbers-module--Number--2McjO";
export var Current = "Numbers-module--Current--l1bow";
export var arrowLeft = "Numbers-module--arrowLeft--QQM7h";
export var arrowRight = "Numbers-module--arrowRight--aO+Tf";